import { render } from "./analysisAnswer.vue?vue&type=template&id=a60c5d42&scoped=true&ts=true&lang=pug"
import script from "./analysisAnswer.vue?vue&type=script&lang=ts"
export * from "./analysisAnswer.vue?vue&type=script&lang=ts"

import "./analysisAnswer.vue?vue&type=style&index=0&id=a60c5d42&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a60c5d42"]])

export default __exports__